module.exports = __webpack_public_path__ + "assets/image-placeholder.1fffcdce.svg";